const RANKING = [
  { rank: 1, title: '繁花', type: '电视剧', hot: '🔥 本周最热', desc: '王家卫导演首部剧集，胡歌主演的上海故事引发全网追剧热潮' },
  { rank: 2, title: '热辣滚烫', type: '电影', hot: '🔥 新片上线', desc: '贾玲执导并主演的励志喜剧，院线转网后热度持续飙升' },
  { rank: 3, title: '庆余年 第二季', type: '电视剧', hot: '📈 热度飙升', desc: '张若昀主演古装权谋大剧回归，首播即创平台播放量新高' },
  { rank: 4, title: '周处除三害', type: '电影', hot: '⭐ 高分推荐', desc: '阮经天主演的台湾犯罪动作片，豆瓣高分口碑黑马之作' },
  { rank: 5, title: '奔跑吧·生态篇', type: '综艺', hot: '🆕 持续热播', desc: '热门户外真人秀新一季，明星阵容升级，笑点密集不间断' },
];

export default function RankingSection() {
  const getRankColor = (rank: number) => {
    if (rank === 1) return 'bg-primary-500 text-white';
    if (rank === 2) return 'bg-accent-500 text-white';
    if (rank === 3) return 'bg-accent-300 text-accent-900';
    return 'bg-secondary-200 text-secondary-700';
  };

  return (
    <section id="ranking" className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4 whitespace-nowrap">
            <i className="ri-trophy-line mr-1"></i>下载排行
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            热门影视下载排行榜
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            基于91影视看片APP用户播放与下载数据，实时反映最受欢迎的影视内容
          </p>
        </div>

        <div className="space-y-3">
          {RANKING.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-4 md:gap-6 p-4 md:p-5 bg-background-50 rounded-2xl border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer group"
            >
              <div className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl font-heading font-bold text-lg shrink-0 ${getRankColor(item.rank)}`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full whitespace-nowrap">
                    {item.type}
                  </span>
                </div>
                <p className="text-sm text-foreground-500">{item.desc}</p>
              </div>
              <span className="text-xs md:text-sm font-medium text-primary-600 whitespace-nowrap shrink-0">{item.hot}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}